import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }

import Input from "@/components/atoms/BaseInput.vue";
import Label from "@/components/atoms/BaseLabel.vue";

// Types
import type { SizesKeysType } from "@/types/sizes.type";
import { SizesKeys } from "@/types/sizes.type";

//Component types & definitions
import { Types as InputTypes } from "../../atoms/Input";
import {
  VariantKeys as InputLabelVariantKeys,
  VariantsType as InputLabelVariantKeysType,
  variantCombination as InputLabelVariantCombination,
} from "@/components/molecules/inputLabel/InputLabel";
import { genericVariants } from "@/helpers/components/genericVariants.helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputLabel',
  props: {
    type: { default: InputTypes.text },
    modelValue: { default: "" },
    variant: { default: InputLabelVariantKeys.primary },
    size: { default: SizesKeys.default },
    block: { type: Boolean, default: false },
    full: { type: Boolean, default: true },
    label: { default: undefined },
    tag: { default: undefined },
    message: {},
    placeholder: {},
    required: { type: Boolean },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    min: {},
    max: {},
    fontMono: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "input", "change", "blur", "focus", "click"],
  setup(__props: any, { emit: __emit }) {

//Components


const emit = __emit;

const UpdateValue = (value: string) => {
  emit("update:modelValue", value);
};

const OnInput = (ev: Event) => {
  emit("input", ev);
};

const OnChange = (ev: Event) => {
  emit("change", ev);
};

const OnBlur = (ev: Event) => {
  emit("blur", ev);
};

const OnFocus = (ev: Event) => {
  emit("focus", ev);
};

const OnClick = (ev: Event) => {
  emit("click", ev);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      block: _ctx.block,
      'w-full': _ctx.full,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createBlock(Label, {
            key: 0,
            variant: _unref(InputLabelVariantCombination)[_ctx.variant].label,
            size: _ctx.size
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ]),
            _: 1
          }, 8, ["variant", "size"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("span", { class: "text-xs text-gray-400 p-1 flex flex-col justify-end" }, _toDisplayString(_ctx.tag), 513), [
        [_vShow, _ctx.tag]
      ])
    ]),
    _createVNode(Input, {
      modelValue: _ctx.modelValue,
      type: _ctx.type,
      placeholder: _ctx.placeholder,
      variant: _unref(InputLabelVariantCombination)[_ctx.variant].input,
      size: _ctx.size,
      full: _ctx.full,
      readonly: _ctx.readonly,
      fontMono: _ctx.fontMono,
      "onUpdate:modelValue": UpdateValue,
      onInput: OnInput,
      onFocus: OnFocus,
      onChange: OnChange,
      onBlur: OnBlur,
      onClick: OnClick
    }, null, 8, ["modelValue", "type", "placeholder", "variant", "size", "full", "readonly", "fontMono"]),
    _withDirectives(_createElementVNode("p", {
      class: _normalizeClass([
        (_unref(genericVariants)?.[_ctx.variant]?.classes, _ctx.fontMono ? 'font-mono' : '')
      , "text-xs m-0.5"])
    }, _toDisplayString(_ctx.message), 3), [
      [_vShow, _ctx.message]
    ])
  ], 2))
}
}

})